import { render, staticRenderFns } from "./damagedParts.pug?vue&type=template&id=e9000684&lang=pug&"
import script from "./damagedParts.js?vue&type=script&lang=js&"
export * from "./damagedParts.js?vue&type=script&lang=js&"
import style0 from "./damagedParts.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9000684')) {
      api.createRecord('e9000684', component.options)
    } else {
      api.reload('e9000684', component.options)
    }
    module.hot.accept("./damagedParts.pug?vue&type=template&id=e9000684&lang=pug&", function () {
      api.rerender('e9000684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagedParts/index.vue"
export default component.exports